<script>
import GameReplay from "@/components/visionTrainTrack/GameReplay.vue";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import moment from "moment";
import { MapGender } from "@/common/util";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
export default {
  components: {
    GameReplay,
    PagenationContainer
  },
  props: {
    type: {}
  },
  data() {
    const ROLE_GROUP_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_GROUP_OPTOMETRIST") > -1;
    const ROLE_AGENT_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    const ROLE_DOCTOR =
      localStorage.getItem("roles").indexOf("ROLE_DOCTOR") > -1;
    const CanEdit = ROLE_DOCTOR || ROLE_AGENT_OPTOMETRIST;
    const stationId = this.$route.params.stationId;
    const patientId = this.$route.params.patientId;
    const trackId = this.$route.params.trackId;
    const tempSearch = sessionStorage.getItem("searchFormData")
      ? JSON.parse(sessionStorage.getItem("searchFormData"))
      : {};
    const start = moment()
      .subtract(6, "days")
      .format("YYYY-MM-DD");
    const end = moment().format("YYYY-MM-DD");
    const cache = sessionStorage.getItem("time");
    const value = cache
      ? cache.split(",")
      : tempSearch.dateRange
      ? tempSearch.dateRange
      : [start, end];
    return {
      userInfo: {
        patientName: "",
        phone: "",
        gender: "",
        contactName: "",
        location: "",
        birth: "",
        createdAt: "",
        agentName: "",
        stationName: ""
      },
      patientTrainTrack: [],
      stationId,
      patientId,
      ROLE_AGENT_OPTOMETRIST,
      ROLE_GROUP_OPTOMETRIST,
      dateRange: value,
      tableData: [],
      editUser: false,
      editUserArray: [
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "出生年月",
          keyName: "birth",
          type: "datePicker"
        },
        {
          label: "联系人",
          keyName: "contact",
          type: "text"
        },
        {
          label: "手机号",
          keyName: "phone",
          type: "text"
        },
        {
          label: "联系地址",
          keyName: "contactLocation",
          type: "textarea"
        }
      ],
      buttonArray: [
        {
          text: "修改方案",
          key: 0
        }
      ],
      CanEdit,
      showNoteList: false,
      noteList: [],
      trackId,
      pageCount: 0,
      activePage: 1
    };
  },
  computed: {
    createdTime() {
      return `${moment(this.userInfo.createdAt).format("YYYY-MM-DD")}`;
    },
    birthDay() {
      return `${
        this.userInfo.birth ? moment().diff(this.userInfo.birth, "years") : "--"
      }岁`;
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    const tempData = {
      patientId: this.patientId,
      time: moment().format("YYYY-MM-DD HH:mm:ss"),
      trainList: []
    };
    // console.log('>>>>>>', tempData)
    localStorage.setItem("activeHandlePatient", JSON.stringify(tempData));
  },
  methods: {
    async loadData() {
      let params = {};
      if (this.dateRange && this.dateRange.length > 0) {
        params.start = this.dateRange[0];
        params.end = this.dateRange[1];
      }
      if (this.stationId) {
        params.stationId = this.stationId;
      }
      let data = await this.$http.getPatientDetailById(params, this.patientId);
      if (data) {
        for (let key in this.userInfo) {
          if (data[key]) {
            if (key === "gender") {
              this.userInfo[key] = MapGender(data[key]);
            } else {
              this.userInfo[key] = data[key];
            }
          }
        }
        this.userInfo.name = data.patientName;
        this.userInfo.contact = data.contactName;
        this.userInfo.contactLocation = data.location;
        this.userInfo.stimulusLevel = data.stimulusLevel;
        this.userInfo.agentName = data.agentName;
        this.userInfo.stationName = data.stationName;
        if (data.trackResources && data.trackResources.content) {
          const arr = cloneDeep(data.trackResources.content);
          const sortArr = sortBy(arr, "trainingAt").reverse();
          this.patientTrainTrack = sortArr.map(o => {
            if (
              o.remark ||
              o.customRemark ||
              o.trainingRemark ||
              o.customTrainingRemark
            ) {
              const note = `训练情况：${
                o.trainingRemark ? o.trainingRemark + "#" : ""
              }${o.customTrainingRemark || ""}；
                处理方式：${o.remark ? o.remark + "#" : ""}${o.customRemark ||
                ""}`;
              o.note1 = `训练情况：${
                o.trainingRemark ? o.trainingRemark + "#" : ""
              }${o.customTrainingRemark || ""}；`;
              o.note2 = `
                处理方式：${o.remark ? o.remark + "#" : ""}${o.customRemark ||
                ""}`;
              o.note = note;
            }
            let isAllWell = o.gameTrackList.length > 0 ? true : false;
            for (let i = 0; i < o.gameTrackList.length; i++) {
              if (
                !(
                  (o.trainingResult[i].exitType == "NORMAL_GAME_OVER_EXIT" ||
                    o.gameTrackList[i].realTrainedDuration >= 570) &&
                  o.gameTrackList[i].quality >= 20
                )
              ) {
                isAllWell = false;
              }
            }
            o.isAllWell = isAllWell;
            return o;
          });
        }
      }
    },
    onSubmit() {
      // console.log("submit!", this.formInline);
    },
    onEditAccount(data) {
      // console.log("onEditAccount!", data);
    },
    onOperationClick(data) {
      // console.log("submit!", data);
    },
    onChangeDate(data) {
      // console.log("--->", data);
      this.dateRange = data;
      this.loadData();
    },
    onEditRemark() {
      this.loadData();
    },
    gotoTrainDetail() {
      let routeData = this.$router.resolve({
        name: "commercialPreview",
        path: `/index/patientManagement/patientManagementDetail/${this.patientId}/${this.stationId}`
      });
      window.open(routeData.href, "_blank");
    },
    async showPatientNoteList() {
      await this.getNoteList();
      this.showNoteList = true;
    },
    async getNoteList() {
      const params = {
        page: this.activePage - 1
      };
      const result = await this.$http.getPatientNoteList(
        this.patientId,
        params
      );

      this.pageCount = result.totalPages;
      this.noteList = result.content.map(o => {
        if (
          o.remark ||
          o.customRemark ||
          o.trainingRemark ||
          o.customTrainingRemark
        ) {
          const note = `训练情况：${
            o.trainingRemark ? o.trainingRemark + "#" : ""
          }${o.customTrainingRemark || ""}；
                处理方式：${o.remark ? o.remark + "#" : ""}${o.customRemark ||
            ""}`;
          o.note = note;
        }

        return o;
      });
    },
    async getNextPatient() {
      const trainActivePageNumber =
        sessionStorage.getItem("trainActivePageNumber") || 1;
      const searchFormData = sessionStorage.getItem("searchFormData")
        ? JSON.parse(sessionStorage.getItem("searchFormData"))
        : {
            name: undefined,
            phone: undefined,
            trainingCompleted: undefined,
            trackState: "NEED_REVIEW",
            start: undefined,
            end: undefined,
            provinceCity: undefined,
            dateRange: [
              moment()
                .subtract(6, "days")
                .format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            ]
          };
      let params = {
        page: parseInt(trainActivePageNumber) - 1,
        size: 10,
        all: false
      };
      for (let key in searchFormData) {
        if (key === "provinceCity") {
          if (searchFormData[key]) {
            if (searchFormData[key][0]) {
              params.provinceId = searchFormData[key][0];
            }
            if (searchFormData[key][1]) {
              params.districtId = searchFormData[key][1];
            }
          }
        } else if (key === "dateRange" && searchFormData.dateRange) {
          if (searchFormData.dateRange[0]) {
            params.start = searchFormData.dateRange[0];
          }
          if (searchFormData.dateRange[1]) {
            params.end = searchFormData.dateRange[1];
          }
        } else if (key === "trainingCompleted") {
          if (searchFormData.trainingCompleted === "true") {
            params[key] = true;
          } else if (searchFormData.trainingCompleted === "false") {
            params[key] = false;
          }
        } else if (searchFormData[key] !== undefined) {
          params[key] = searchFormData[key];
        }
      }
      if (this.ROLE_AGENT_OPTOMETRIST) {
        params.stationId = this.stationId;
      }
      const result = await this.$http.getNextPatientTrainTrack(
        this.trackId,
        params
      );
      if (result) {
        const activePage = parseInt(result.pageRequest.pageNumber) + 1;
        sessionStorage.setItem("trainActivePageNumber", activePage);
        this.$router.push({
          path: `/index/visionTrainTrack/visionTrainTrackDetail/${result.patientId}/${result.stationId}/${result.trackId}`
        });
        this.$emit("routerRefresh", "refresh");
      }
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.getNoteList();
    }
  }
};
</script>
<template>
  <div class="trainDetailIndex">
    <el-alert
      v-if="userInfo.stimulusLevel === null"
      type="error"
      title="该患者尚未配置刺激等级！"
      :closable="false"
      center
      class="forgetStimulusLevelAlert"
    />
    <el-card class="box-card cardStyle" shadow="never">
      <div class="text">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="headerText">
                  {{userInfo.patientName}}
                  <img
                    v-if="userInfo.gender === '女'"
                    class="genderStyle"
                    src="@/assets/female.png"
                  />
                  <img v-if="userInfo.gender === '男'" class="genderStyle" src="@/assets/male.png" />
                  <span>{{birthDay}}</span>
                  <DialogForm
                    v-if="editUser"
                    :defaultValue="userInfo"
                    formTitle="编辑"
                    :formInputArray="editUserArray"
                    @close="editUser = false"
                    @submitForm="onEditAccount"
                  />
                  <!-- <i class="el-icon-edit editIcon" v-if="ROLE_AGENT_OPTOMETRIST" @click="editUser = true"></i> -->
                  <!-- <el-button class="editButton" @click="gotoTrainDetail">训练详情</el-button> -->
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">联系人：</div>
                <span class="detailText">{{userInfo.contactName}}</span>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">联系地址：</div>
                <span class="detailText">{{userInfo.location}}</span>
              </el-col>
            </el-row>-->
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">创建时间：</div>
                <span class="detailText">{{createdTime}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">联系电话：</div>
                <span class="detailText">{{userInfo.phone}}</span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">代理商：</div>
                <span class="detailText">{{userInfo.agentName}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">医疗机构：</div>
                <span class="detailText">{{userInfo.stationName}}</span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="24">
              <el-col :span="24" style="text-align: right">
                <el-button type="text" size="medium" @click="getNextPatient">
                  查看下一个患者
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24" style="text-align: right">
                <el-button type="primary" size="medium" @click="gotoTrainDetail">
                  修改方案
                  <img class="nextIconStyle" src="@/assets/nextIcon.png" />
                </el-button>
                <el-button type="primary" size="medium" @click="showPatientNoteList">患者备注</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <el-drawer :visible.sync="showNoteList" direction="rtl" size="50%" style="overflow-y: auto;">
        <span slot="title" style="font-size: 22px">患者备注</span>
        <el-table
          :data="noteList"
          style="margin: 0 10px;height: 500px;width: 95%;overflow-y: auto;"
        >
          <el-table-column property="trainingAt" label="备注日期" width="100"></el-table-column>
          <el-table-column property="handler" label="备注账号" width="135"></el-table-column>
          <el-table-column property="note" label="备注内容"></el-table-column>
        </el-table>
        <PagenationContainer v-if="pageCount > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="activePage"
            :page-count="pageCount"
            layout="prev, pager, next, jumper"
          ></el-pagination>
        </PagenationContainer>
      </el-drawer>
    </el-card>
    <GameReplay
      @onChangeDate="onChangeDate"
      @onEditRemark="onEditRemark"
      :patientTrainTrack="patientTrainTrack"
      :patientId="patientId"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/css/color.scss";

.trainDetailIndex {
  .line {
    width: auto;
    height: 1px;
    background-color: #ebebeb;
    margin-bottom: 15px;
  }

  .cardStyle {
    margin: 0 2%;
    border: 0px;
  }

  .addButton {
    width: 120px;
    height: 38px;
    // margin-top: 13px;
    border-radius: 3px;
    margin: 10px 3%;
  }

  .accountTable {
    margin: 20px 3%;
    border: 1px;
    width: 94%;
  }

  .el-row {
    display: flex;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-col {
    align-self: center;
    border-radius: 4px;
  }

  .grid-content {
    padding: 15px 0px;
    border-radius: 4px;
  }

  .text {
    font-size: 14px;
    .headerText {
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: bold;
      > span {
        font-size: 14px;
      }
      .genderStyle {
        height: 17.5px;
        margin-bottom: -2px;
      }
    }
  }

  .item {
    line-height: 33px;
    display: inline-block;
    font-size: 14px;
    color: #000000;
    font-weight: 500;
    width: 70px;
  }
  .detailText {
    color: rgba(0, 0, 0, 0.65);
  }

  .nextIconStyle {
    width: 12px;
    height: 12px;
    margin-left: 5px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .editIcon {
    display: inline-block;
    margin-left: 50px;
    padding: 10px;
    font-size: 18px;
    color: #00c1de;
    cursor: pointer;
  }
  .editButton {
    float: right;
    background-color: #00c1de;
    border-color: #00c1de;
    color: #fff;
    margin-left: 10px;
  }
  .noteListDrawer {
    .el-drawer__header {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionTrainTrack/visionTrainDetail.vue